export const ResidentAlreadyAssignedToTheAddress = 'ResidentAlreadyAssignedToTheAddress';
export const IssuedKeyCannotBeRemoved = 'IssuedKeyCannotBeRemoved';
